import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { outletMasterDetail } from '@/features/outlet/api'
import { OutletFormUpdate } from '@/features/outlet/components/outlet-form'

export const Route = createFileRoute('/_app/settings/outlet/$id')({
	loader: async ({ context, params }) => {
		const { qc } = context
		const { id } = params
		await qc.fetchQuery(outletMasterDetail.qry({ id }))
		return
	},
	component: Component,
})

function Component() {
	const { id } = Route.useParams()
	const qry = useSuspenseQuery(outletMasterDetail.qry({ id }))

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/outlet', 'Outlet'],
					[Route.fullPath, qry.data.outlet.name],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Edit Outlet" />
				<OutletFormUpdate />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
